export var processLazyPreloader = function processLazyPreloader(swiper, imageEl) {
  var slideSelector = function slideSelector() {
    return swiper.isElement ? "swiper-slide" : ".".concat(swiper.params.slideClass);
  };
  var slideEl = imageEl.closest(slideSelector());
  if (slideEl) {
    var lazyEl = slideEl.querySelector(".".concat(swiper.params.lazyPreloaderClass));
    if (lazyEl) lazyEl.remove();
  }
};